// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tip[data-v-5f291dbf] {\n  margin: 0.53333rem 0;\n}\n.next-btn[data-v-5f291dbf] {\n  width: 2.66667rem;\n  margin-top: 1.06667rem;\n}\n", ""]);
// Exports
module.exports = exports;
